import React, { Component } from 'react';
import Store from 'stores/TariffsStore';
import { getTariffs, removeTariff, getTariffsUsage, } from 'utils/TariffAPIUtils';
import paginate from 'utils/pagination-util';
import { findIndex } from 'lodash/array';
import * as Table from 'reactabular-table';
import * as sort from 'sortabular';
import * as Search from 'searchtabular';
import orderBy from 'lodash/orderBy';
import { OverlayTrigger, Tooltip, Pagination } from 'react-bootstrap';
import SessionStore from 'stores/SessionStore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import Container from '../../v2/container';
import AddButton from '../../v2/buttons/AddButton';
import EditButton from '../../v2/buttons/EditButton';
import DeleteButton from '../../v2/buttons/DeleteButton';
import CopyButton from '../../v2/buttons/CopyButton';
import TariffEditorModal from './TariffEditorModal';
import TariffConfirmationButton from './TariffConfirmationButton';
const hasTariffRole = () => {
    return (SessionStore.getUserRoles().indexOf('tariff') > -1 ||
        SessionStore.getUserRoles().indexOf('admin') > -1);
};
const extendTariffsWithUsage = (tariffs, usage) => {
    return tariffs.map((tariff) => {
        tariff.numberOfShippers = usage[tariff._id] || 0;
        return tariff;
    });
};
const getStateFromStore = () => {
    let tariffs = Store.getTariffs();
    const usage = Store.getUsage();
    tariffs = extendTariffsWithUsage(tariffs, usage);
    return {
        tariffs: tariffs,
        usage: usage,
    };
};
class TariffsTable extends Component {
    constructor(props, context) {
        super(props, context);
        this.onChange = () => {
            this.setState(getStateFromStore());
        };
        this.newTariff = () => {
            this.setState({ showEditor: true });
        };
        this.handleTariffDelete = (tariff, password) => {
            if (tariff) {
                Store.reset();
                removeTariff(tariff, password);
            }
        };
        this.onSelect = (eventKey) => {
            this.setState((prevState) => {
                let pagination = prevState.pagination || {};
                pagination.page = eventKey - 1;
                return { pagination };
            });
        };
        this.onPerPage = (e) => {
            const { value } = e.target;
            this.setState((prevState) => ({
                pagination: Object.assign(Object.assign({}, (prevState.pagination || {})), { perPage: parseInt(value, 10) }),
            }));
        };
        const getSortingColumns = () => this.state.sortingColumns || {};
        const sortable = sort.sort({
            getSortingColumns,
            onSort: (selectedColumn) => {
                this.setState((prevState) => ({
                    sortingColumns: sort.byColumns({
                        // sort.byColumn would work too
                        sortingColumns: prevState.sortingColumns,
                        selectedColumn,
                    }),
                }));
            },
        });
        const { t } = props;
        this.state = {
            query: {},
            searchColumn: 'all',
            sortingColumns: null,
            pagination: {
                page: 0,
                perPage: 10,
            },
            columns: [
                {
                    property: 'name',
                    header: {
                        label: t('NAME'),
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                    cell: {
                        formatters: [Search.highlightCell],
                    },
                },
                {
                    property: 'type',
                    header: {
                        label: t('TYPE'),
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                    cell: {
                        formatters: [Search.highlightCell],
                    },
                },
                {
                    property: 'markets',
                    header: {
                        label: titleize(t('MARKET', { count: 2 })),
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                    cell: {
                        formatters: [
                            (value) => {
                                return value.toString();
                            },
                            Search.highlightCell,
                        ],
                    },
                },
                {
                    property: 'is_default',
                    header: {
                        label: t('DEFAULT_FOR_MARKET'),
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                    cell: {
                        formatters: [Search.highlightCell],
                    },
                },
                {
                    property: 'numberOfShippers',
                    header: {
                        label: t('OF_ASSIGNED_SHIPPERS'),
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                    cell: {
                        formatters: [Search.highlightCell],
                    },
                },
                {
                    header: {
                        formatters: [
                            () => hasTariffRole() && React.createElement(AddButton, { onClick: this.newTariff }),
                        ],
                    },
                    cell: {
                        formatters: [
                            (value, { rowData }) => {
                                const idx = findIndex(this.state.tariffs, {
                                    _id: rowData._id,
                                });
                                let tariff = this.state.tariffs[idx];
                                const remove = (password) => {
                                    this.handleTariffDelete(tariff, password);
                                };
                                const edit = () => {
                                    this.setState({ showEditor: true, tariff: tariff });
                                };
                                const clone = () => {
                                    tariff = JSON.parse(JSON.stringify(tariff));
                                    delete tariff._id;
                                    tariff.name += '_copy';
                                    this.setState({ showEditor: true, tariff: tariff });
                                };
                                const removeControl = (React.createElement(OverlayTrigger, { placement: "left", overlay: React.createElement(Tooltip, { id: tariff._id }, titleize(t('REMOVE'))) },
                                    React.createElement("div", null,
                                        React.createElement(DeleteButton, null))));
                                if (!hasTariffRole)
                                    return React.createElement("span", null, t('ACTIONS_UNAVAILABLE'));
                                return (React.createElement("div", { className: "flex items-center space-x-2" },
                                    React.createElement(TariffConfirmationButton, { controlTitle: removeControl, controlType: "icon", skipConfirmation: false, alertTitle: t('WARNING'), message: t('IMPACT_CUSTOMERS_MSG'), confirmTitle: t('CONFIRM_REMOVE'), dismissTitle: titleize(t('CANCEL')), onConfirm: remove.bind(this), store: Store }),
                                    "\u00A0",
                                    React.createElement(OverlayTrigger, { placement: "top", overlay: React.createElement(Tooltip, { id: tariff._id }, t('EDIT')) },
                                        React.createElement("div", null,
                                            React.createElement(EditButton, { style: { cursor: 'pointer', color: 'green' }, onClick: edit.bind(this) }))),
                                    "\u00A0",
                                    React.createElement(OverlayTrigger, { placement: "right", overlay: React.createElement(Tooltip, { id: tariff._id }, titleize(t('CLONE'))) },
                                        React.createElement(CopyButton, { onClick: clone.bind(this) }))));
                            },
                        ],
                    },
                },
            ],
        };
    }
    componentDidMount() {
        Store.addChangeListener(this.onChange);
        getTariffsUsage();
        getTariffs();
    }
    componentWillUnmount() {
        Store.removeChangeListener(this.onChange);
    }
    render() {
        const { t } = this.props;
        let tariffs = this.state.tariffs;
        const columns = this.state.columns;
        const searchColumn = this.state.searchColumn;
        const query = this.state.query;
        const pagination = this.state.pagination;
        const tariff = this.state.tariff;
        const showEditor = this.state.showEditor;
        const sortingColumns = this.state.sortingColumns;
        if (tariffs && this.state.query) {
            tariffs = Search.highlighter({
                columns: columns,
                matches: Search.matches,
                query,
            })(Search.multipleColumns({ columns, query })(tariffs));
        }
        tariffs = sort.sorter({
            columns: columns,
            sortingColumns,
            sort: orderBy,
        })(tariffs);
        const paginated = paginate(tariffs, pagination);
        let totalPages = 0;
        if (pagination.perPage && tariffs) {
            totalPages = Math.ceil(tariffs.length / pagination.perPage);
        }
        const close = () => {
            this.setState({ showEditor: false, tariff: null });
        };
        let modal = React.createElement("div", null);
        if (showEditor) {
            modal = (React.createElement(TariffEditorModal, { tariffsList: this.state.tariffs, className: "tariff-wrapper", tariff: tariff, onClose: close.bind(this), show: true }));
        }
        const paginationLabel = t('PAGE_CURRENT_TOTAL', {
            current: pagination.page + 1,
            total: totalPages,
        });
        return (React.createElement(Container, null,
            React.createElement("div", { className: "mt-10 tariff-wrapper" },
                React.createElement("h1", { className: "my-0 mb-4 text-xl" }, t('TARIFFS')),
                React.createElement("div", { className: "mb-2 w-max" },
                    React.createElement(Search.Field, { column: searchColumn, query: query, columns: columns, rows: paginated.data, className: "flex items-center form-group", i18n: { all: titleize(t('ALL')) }, components: {
                            props: {
                                select: {
                                    className: 'form-select',
                                },
                                filter: {
                                    className: 'ml-2 form-field',
                                    placeholder: titleize(t('SEARCH')),
                                },
                            },
                        }, onColumnChange: (selectedColumn) => {
                            this.setState({ searchColumn: selectedColumn });
                        }, onChange: (currentQuery) => {
                            this.setState({ query: currentQuery });
                        } })),
                React.createElement("div", { className: "overflow-x-auto shadow rounded-md" },
                    React.createElement(Table.Provider, { className: "default-table", columns: columns },
                        React.createElement(Table.Header, null),
                        React.createElement(Table.Body, { rows: paginated.data, rowKey: "_id" }))),
                React.createElement("div", { className: "flex flex-wrap items-center justify-between" },
                    React.createElement(Pagination, { prev: true, next: true, first: true, last: true, ellipsis: true, items: paginated.amount, maxButtons: 10, activePage: pagination.page + 1, label: t('PAGE'), onSelect: (eventKey) => this.onSelect(eventKey) }),
                    React.createElement("div", { className: "flex items-center -mx-8 wrap" },
                        React.createElement("div", { className: "px-8" },
                            React.createElement("div", { className: "flex items-center" },
                                React.createElement("label", { className: "mr-2 form-label" }, t('PER_PAGE')),
                                React.createElement("input", { type: "number", className: "w-20 form-field", value: this.state.pagination.perPage, onChange: this.onPerPage }))),
                        React.createElement("h4", { className: "px-8 my-0" }, paginationLabel))),
                React.createElement("div", null, modal))));
    }
}
export default withTranslation()(TariffsTable);
